module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-547.8fe0869.woff2";